import React from 'react'

import { UrlProvider } from 'urls'

import { Badge } from 'components/_base'
import { Table } from 'components/table'
import { UsersFilters } from 'components/users'
import { usePaginatedTableMeta } from 'hooks/usePaginatedTableMeta'
import { useUsers } from 'hooks/useUsers'
import { isAlbacrossAdmin } from 'models/user-model'
import { formatDate } from 'utils/date'

const config = [
  {
    title: 'Email',
    render: ({ deleted_at, email }: any) => (
      <>
        {email && <span className="users__name">{email}</span>}
        {deleted_at && <Badge color="red" text="Deleted" />}
      </>
    ),
    sort: 'email',
    noBreak: true,
  },
  {
    title: 'First name',
    field: 'first_name',
    sort: 'first_name',
  },
  {
    title: 'Last name',
    field: 'last_name',
    sort: 'last_name',
  },
  {
    title: 'Admin',
    render: (user: any) => (isAlbacrossAdmin(user) ? 'Yes' : 'No'),
  },
  {
    title: 'Last Logged In',
    render: ({ last_login }: any) => (last_login ? formatDate(last_login) : 'Unknown'),
    sort: 'last_login',
  },
  {
    title: 'Last Active',
    render: ({ last_active_at }: any) => (last_active_at ? formatDate(last_active_at) : 'Unknown'),
    sort: 'last_active_at',
  },
  {
    title: 'Created',
    render: ({ created_at }: any) => formatDate(created_at),
    sort: 'created_at',
  },
]

const Users = () => {
  const { meta, setPage, setRowsPerPage, setSort, setFilters } = usePaginatedTableMeta(
    {
      filters: { admin: false, search: '', showDeleted: false },
    },
    'users',
  )
  const { data, isLoading, error } = useUsers(meta)

  const handleSort = (property: any) => () => setSort(property)
  const getRowLink = (user: any) => UrlProvider.getUrl('user', { id: user.id })

  return (
    <Table
      config={config}
      count={data?.count}
      data={data?.items}
      error={error ? 'Error occurred when loading users data' : undefined}
      getRowLink={getRowLink}
      hover
      loading={isLoading}
      onChangePage={setPage}
      onChangeRowsPerPage={setRowsPerPage}
      onSort={handleSort}
      page={meta.page}
      rowsPerPage={meta.rowsPerPage}
      sortBy={meta.sortBy}
      sortOrder={meta.sortOrder}
      title="Users"
      toolbar={<UsersFilters initialValues={meta.filters} setFilters={setFilters} />}
    />
  )
}

export default Users
